import { render, staticRenderFns } from "./rolePermission.vue?vue&type=template&id=d3f8ce48&scoped=true&"
import script from "./rolePermission.vue?vue&type=script&lang=js&"
export * from "./rolePermission.vue?vue&type=script&lang=js&"
import style0 from "./rolePermission.vue?vue&type=style&index=0&id=d3f8ce48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f8ce48",
  null
  
)

export default component.exports